// Components/RoomFacilitesTable.jsx
import React from "react";
import DataTable from "../../../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../../../Common/DataTableHeader/DataTableHeader";
import { roomFacilitesColumns } from "./RoomFacilitesData";

const RoomFacilitesTable = ({ data, loading, onEdit, onDelete }) => {
  const tableData = data.map((item, idx) => ({
    facilitesId: idx + 1,
    facilitesName: item.name,
    active: item.active ? (
      <span className="badge bg-success">Active</span>
    ) : (
      <span className="badge bg-secondary">Inactive</span>
    ),
    actions: (
      <>
        <button
          className="btn btn-sm btn-outline-primary me-2"
          onClick={() => onEdit(item)}
        >
          <i className="bi bi-pencil-square"></i>
        </button>

        <button
          className="btn btn-sm btn-outline-danger"
          onClick={() => onDelete(item.id)}
        >
          <i className="bi bi-trash"></i>
        </button>
      </>
    ),
  }));

  return (
    <>
      <DataTableHeader />
      {loading ? (
        <p className="text-center py-4">
          <span className="spinner-border"></span>
        </p>
      ) : (
        <DataTable columns={roomFacilitesColumns} data={tableData} />
      )}
    </>
  );
};

export default RoomFacilitesTable;
